// Il campo "conservazione" della ricetta è testo libero e può iniziare con la
// fase produttiva da cui deriva (es. "DOPO ABBATTIMENTO, CONSERVARE
// REFRIGERATO", "DOPO L'ABBATTIMENTO DEVE ESSERE CONSERVATO IN FRIGO...").
// Su etichette e Libro Ingredienti va indicata solo la modalità di
// conservazione: se il testo inizia con "DOPO <fase produttiva> ..."
// (abbattimento, cottura, ...) e contiene più avanti
// "CONSERVA...", si mantiene solo da quel punto in poi (un participio
// "CONSERVATO/A/I/E" diventa "CONSERVARE"). Stessa regola lato server in
// backend/recipe_rules.py (conservation_display_text). `recipe.conservation`
// non viene mai modificato.
// "DOPO L'APERTURA/LO SCONGELAMENTO" restano: sono istruzioni per il consumatore.
const PRODUCTION_PHASE = /ABBATT|COTTUR|RAFFREDD|RIGENER|CONGELAMENT|SURGELAZ|PREPARAZ|PRODUZ|LAVORAZ|CONFEZION/i;

export function conservationDisplayText(text) {
  if (!text) return text;
  const match = text.match(/\bCONSERVA\w*/i);
  const prefix = match ? text.slice(0, match.index).trim() : "";
  if (!prefix.toUpperCase().startsWith("DOPO") || !PRODUCTION_PHASE.test(prefix) || /SCONGELAMENT/i.test(prefix)) return text;
  const result = text.slice(match.index).replace(/^[\s,.;:]+|[\s,.;:]+$/g, "");
  return result.replace(/^CONSERVAT[OAIE]\b/i, (word) => (word === word.toUpperCase() ? "CONSERVARE" : "conservare"));
}
